/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Inactive_LabelInputs */

const vi_product_inactive_label = /** @type {(inputs: Product_Inactive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng hoạt động`)
};

/**

* @param {Product_Inactive_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_inactive_label = /** @type {((inputs?: Product_Inactive_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Inactive_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_inactive_label(inputs)
});